import React from 'react';
import { Link, graphql } from 'gatsby';
import styled from 'styled-components';

import Layout from '../components/layout';
import SEO from '../components/seo';
import Post, { Node } from '../components/post';
import { rhythm } from '../utils/typography';

type Props = {
  pageContext: {
    tag: string;
  };
  data: {
    allMarkdownRemark: {
      totalCount: number;
      edges: {
        node: Node;
      }[];
    };
  };
};

const Title = styled.h1`
  margin-top: ${rhythm(1)};
  margin-bottom: ${rhythm(1)};
`;

const Divider = styled.hr`
  margin-bottom: ${rhythm(1)};
`;

const Pagination = styled.nav`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  list-style: none;
  padding: 0;
  margin-bottom: ${rhythm(1)};
`;

const Tags: React.FC<Props> = ({ pageContext, data }) => {
  const { tag } = pageContext;
  const { edges, totalCount } = data.allMarkdownRemark;
  const tagHeader = `${totalCount} post${
    totalCount === 1 ? '' : 's'
  } tagged with "${tag}"`;
  return (
    <Layout>
      <SEO title={tag} />
      <Title>{tagHeader}</Title>
      {edges.map(({ node }) => (
        <Post node={node} key={node.fields.slug} />
      ))}
      <Divider />
      <Pagination>
        <Link to="/tags">← All tags</Link>
      </Pagination>
    </Layout>
  );
};

export default Tags;

export const pageQuery = graphql`
  query($tag: String) {
    allMarkdownRemark(
      limit: 2000
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      totalCount
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            tags
          }
          html
        }
      }
    }
  }
`;
